export default {
  iframe: '/iframe',
  teamsSuccess: '/teams-success',
  home: '/',
  login: '/login',
  register: '/register',
  emailVerify: '/verify',
  invite: '/invite',
  passwordReset: '/passwordReset',
  integration: {
    verify: {
      hubspot: '/verify/hubspot',
      salesforce: '/verify/salesforce',
      slack: '/verify/slack',
      msteams: '/verify/msteams',
      zendesk: '/verify/zendesk',
    },
    redirect: '/redirect/:appName',
  },
  project: {
    root: '/',
    details: '/',
    billing: '/billing',
    analytic: '/analytic',
    profile: '/settings/profile',
    meeting: '/settings/meeting',
    inbox: {
      root: '/inbox',
      detail: '/inbox/:conversationId',
    },
    audiences: {
      root: '/conversations',
      detail: '/conversations/:conversationId',
    },
    mySettings: '/settings/profile',
    analytics: '/analytics',
    projectSettings: {
      configuration: '/settings/configurations',
      integrations: '/settings/integrations',
      team: '/settings/team',
      widget: '/settings/widget',
      profile: '/settings/profile',
      conversations: {
        root: '/conversations',
        details: '/conversations/:conversationId',
        build: '/conversations/:conversationId/build',
        test: '/conversations/:conversationId/build/test',
      },
      bot: {
        root: '/bot',
        integrations: '/bot/integrations',
        settings: '/bot/settings',
      },
    },
    meetings: '/meetings',
  },
  errorPage: {
    404: '/404',
    500: '/500',
  },
  notAuthorized: '/notAuthorized',
};
